// File: frontend/src/pages/FitenkoPochta.js
// Version: 1.0 (quick-260912-q2c)
// Date: 2026-09-12
// Назначение: экран `/email-inbox` арендатора fitenko на ОБЩЕМ СЛОЕ. Весь
//             рисунок этого экрана — этот файл и раздел 13 `fitenko-shell.css`,
//             и больше нигде. Это граница измерения цены рисунка, а не
//             украшение оглавления.
//
// 🔴 ЭТО ПЕРЕНОС, А НЕ ПЕРЕДЕЛКА. Ни одна надпись, ручка, обработчик и состояние
//    прежнего экрана не потеряны — тождество множеств по четырём осям судит
//    `priemka-pochty.py` (П1), сторона ДО читается `git show b2515714:` У
//    ИСТОЧНИКА, а не из черновика. Перевод надписей на русский в эту задачу НЕ
//    ВХОДИТ: смена языка и смена слоя — разные утверждения, и слить их значило
//    бы лишить приёмку возможности сказать «потеряно».
//
// 🔴 ПРЕЖНИЙ ЭКРАН НЕ УДАЛЁН И НЕ ТРОНУТ. Маршрут `/email-inbox` общий на
//    ЧЕТЫРЁХ арендаторов (`App.js:123`), а правила `fk-*` живут ТОЛЬКО под
//    `html.fitenko`. Развилка стоит в `EmailTriagePage.js` двумя строками: у
//    mlg, eln и elfny путь остаётся прежним побайтно.
//
// 🔴 ШАПКА — `ShapkaBezDeystviya`, И ВЫБОР НЕ ВКУСОВОЙ. Главного действия у
//    экрана НЕТ: действия живут на карточке письма (`Approve & Send`,
//    `Dismiss`), и каждое относится к ОДНОМУ письму, а не ко всему экрану.
//    Поставить «Назад к работе» главным действием справа значило бы предложить
//    человеку УХОД с экрана в виде его главного действия.
//
// 🔴 АДРЕС ВОЗВРАТА БЕРЁТСЯ У ЕДИНСТВЕННОГО ДЕРЖАТЕЛЯ АДРЕСОВ
//    (`config/fitenkoNav.js`, LEGACY_DESTINATIONS), а строкой НЕ пишется.
//    Второй держатель разошёлся бы с первым МОЛЧА — ровно в тот день, когда
//    адрес поменяют в одном месте из двух.
//
// 🔴 НИ ОДНОГО АТРИБУТА `style`. Причина не в чистоплотности: часть перекрытий
//    легаси-слоя опознаёт узел ПО ПОДСТРОКЕ в атрибуте style через
//    `:where([style*="…"])` и бьёт с `!important`. При нуле инлайновых стилей
//    вопрос об их специфичности отпадает ПО ПОСТРОЕНИЮ, а не по оценке.
//
// 🔴 ИМЕНА КЛАССОВ ТОЛЬКО СВОИ, `fk-pochta-*`. Запрещены и ПОЧЕМУ: `btn`,
//    `btn-primary`, `btn-secondary`, `card`, `form-input`, `container`,
//    `page-header`, `results-card`, `no-results`, утилиты `bg-*` и `text-*` —
//    ровно эти имена стоят в перекрытиях `html.fitenko` из `index.css` с
//    `!important` и ПОБЕДИЛИ БЫ общий слой. Пустоту этого пересечения
//    доказывает П3б приёмки, а не обещание в комментарии.
//
// 🔴 ТЕГИ h3, p, label, textarea, button СОХРАНЕНЫ. Гарнитура и цвет заголовка
//    приходят каскадом от `html.fitenko h1..h4`; подмена тега на div изменила бы
//    вид, НИЧЕГО не сказав.
//
// 🔴 ЧЕГО ЭТОТ ПЕРЕНОС НЕ ДОКАЗЫВАЕТ: живой замер на бою НЕ СНЯТ — выкатка
//    условиями задачи запрещена. Доказано «в исходнике и в бандле правило
//    такое», а не «на экране читается».

import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';

import apiService from '../services/apiService';
import { ShapkaBezDeystviya, Sostoyanie } from '../components/FitenkoUzor';
import { LEGACY_DESTINATIONS } from '../config/fitenkoNav';

// Адрес по ключу у держателя адресов. Приём взят дословно у соседнего экрана
// слоя (`FitenkoObrashcheniya.js`) — новых приёмов здесь не изобретается.
const adresPoKlyuchu = (kluch) => {
    const d = LEGACY_DESTINATIONS.find((z) => z.key === kluch);
    return d ? d.path : null;
};

const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        return new Date(dateString).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
    } catch { return dateString; }
};

// --- Карточка одного письма ---
const KartochkaPisma = ({ email, onActionDone }) => {
    const extracted = email.ai_extracted || {};
    const [reply, setReply] = useState(email.ai_draft_reply || '');
    const [working, setWorking] = useState(false);

    const handleApprove = async () => {
        setWorking(true);
        try {
            await apiService.approveEmail(email.id, reply);
            toast.success('Reply approved and sent.');
            onActionDone(email.id);
        } catch (err) {
            toast.error(`Failed to send reply: ${err.message}`);
        } finally {
            setWorking(false);
        }
    };

    const handleDismiss = async () => {
        setWorking(true);
        try {
            await apiService.dismissEmail(email.id);
            toast.success('Email dismissed.');
            onActionDone(email.id);
        } catch (err) {
            toast.error(`Failed to dismiss: ${err.message}`);
        } finally {
            setWorking(false);
        }
    };

    const chips = [
        extracted.visa_type && { label: 'Visa', value: extracted.visa_type },
        extracted.urgency && { label: 'Urgency', value: extracted.urgency },
        extracted.language && { label: 'Language', value: extracted.language },
        extracted.client_phone && { label: 'Phone', value: extracted.client_phone },
    ].filter(Boolean);

    return (
        <article className="fk-pochta-card">
            <div className="fk-pochta-head">
                <div className="fk-pochta-ot">
                    <span className="fk-pochta-ot-imya">{email.from_name || email.from_email}</span>
                    {email.from_name && <span className="fk-pochta-ot-adres">&lt;{email.from_email}&gt;</span>}
                </div>
                <span className="fk-pochta-kogda">{formatDate(email.received_at)}</span>
            </div>

            <h3 className="fk-pochta-tema">{email.subject || '(no subject)'}</h3>

            {email.ai_summary && (
                <div className="fk-pochta-svodka">
                    <span className="fk-pochta-svodka-metka">AI Summary</span>
                    <p className="fk-pochta-svodka-text">{email.ai_summary}</p>
                </div>
            )}

            {chips.length > 0 && (
                <div className="fk-pochta-metki">
                    {chips.map((c) => (
                        <span key={c.label} className="fk-pochta-metka">
                            <strong>{c.label}:</strong> {c.value}
                        </span>
                    ))}
                </div>
            )}

            <label className="fk-pochta-otvet-metka">
                <span>Proposed reply (editable)</span>
                <textarea
                    className="fk-pochta-otvet"
                    value={reply}
                    onChange={(e) => setReply(e.target.value)}
                    rows={6}
                    placeholder="Write or edit the reply before sending..."
                />
            </label>

            <div className="fk-pochta-deystviya">
                <button type="button" className="fk-pochta-act-vtor" onClick={handleDismiss} disabled={working}>
                    {working ? 'Working...' : 'Dismiss'}
                </button>
                <button type="button" className="fk-pochta-act" onClick={handleApprove} disabled={working}>
                    {working ? 'Sending...' : 'Approve & Send'}
                </button>
            </div>
        </article>
    );
};

// --- Экран ---
const FitenkoPochta = () => {
    const [emails, setEmails] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                const data = await apiService.getPendingEmails();
                setEmails(Array.isArray(data) ? data : []);
            } catch (error) {
                toast.error(`Failed to load emails: ${error.message}`);
            } finally {
                setIsLoading(false);
            }
        };
        fetchEmails();
    }, []);

    const handleActionDone = (emailId) => {
        setEmails(prev => prev.filter(e => e.id !== emailId));
    };

    // 🔴 ТРИ ОТВЕТА РАЗНЫМИ СЛОВАМИ: «грузим», «пусто» и список. Одинаковыми
    //    словами они не говорят — иначе «ещё не спросили» и «спросили, и нет»
    //    стали бы неразличимы.
    return (
        <div className="fk-page fk-pochta">
            <ShapkaBezDeystviya
                nadzagolovok="INBOX"
                zagolovok="Email Inbox"
                podstroka="AI-reviewed client emails awaiting your approval."
                nazadKuda={adresPoKlyuchu('dashboard')}
                nazadPodpis="← Назад к работе"
            />

            {isLoading ? (
                <Sostoyanie tekst="Loading emails..." />
            ) : emails.length > 0 ? (
                <div className="fk-pochta-list">
                    {emails.map(email => (
                        <KartochkaPisma key={email.id} email={email} onActionDone={handleActionDone} />
                    ))}
                </div>
            ) : (
                <Sostoyanie tekst="No emails awaiting review." />
            )}
        </div>
    );
};

export default FitenkoPochta;
